import {DEFAULT_LINE_PLOT_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {createNumberDisplayFn} from './displayValueFactory';

export const getMaxRunsDisplayRow = createNumberDisplayFn({
  field: 'maxRuns',
  label: 'Max runs',
  groupTitle: 'Max number of runs',
  defaultValue: DEFAULT_LINE_PLOT_SETTINGS.limit,
});
